import React from 'react';
import _ from 'lodash';

import Button from 'components/Button';
import Table from 'components/Table';

import editIcon from './assets/edit-icon.svg';
import deleteIcon from './assets/delete-icon.svg';

import {openUrlInNewTab} from 'utils/files';
import {formatDate} from 'utils/datetime';

import './styles.css';

const LegacyDocumentRow = ({
  legacyDocument,
  deleteLegacyDocument,
  openLegacyDocumentEditModal
}) => (
  <Table.Row className="legacyDocumentRow">
    <Table.Cell className="title">{legacyDocument.title}</Table.Cell>
    <Table.Cell
      className="file"
      onClick={() => openUrlInNewTab(legacyDocument.document.fileUrl)}>
      {legacyDocument.document.filename}
    </Table.Cell>
    <Table.Cell className="uploaded">
      {formatDate(legacyDocument.document.uploadedAt)}
    </Table.Cell>
    <Table.Cell className="type">
      {_.get(legacyDocument, 'legacyType.name')}
    </Table.Cell>
    <Table.Cell
      className="edit"
      onClick={() => openLegacyDocumentEditModal({legacyDocument})}>
      <img src={editIcon} alt="Edit icon" />
    </Table.Cell>
    <Table.Cell
      className="delete"
      onClick={() => deleteLegacyDocument({legacyDocument})}>
      <img src={deleteIcon} alt="Delete icon" />
    </Table.Cell>
  </Table.Row>
);

const LegacyDocumentsTable = ({
  legacyDocuments,
  openLegacyDocumentUploadModal,
  deleteLegacyDocument,
  openLegacyDocumentEditModal
}) => (
  <div className="LegacyDocumentsTable">
    <Table>
      <Table.Header>
        <Table.HeaderItem className="title" heading="Title" />
        <Table.HeaderItem className="file" heading="File" />
        <Table.HeaderItem className="uploaded" heading="Uploaded" />
        <Table.HeaderItem className="type" heading="Type" />
        <Table.HeaderItem className="edit" />
        <Table.HeaderItem className="delete" />
      </Table.Header>
      <Table.Body>
        {legacyDocuments.map(legacyDocument => (
          <LegacyDocumentRow
            key={legacyDocument.id}
            legacyDocument={legacyDocument}
            deleteLegacyDocument={deleteLegacyDocument}
            openLegacyDocumentEditModal={openLegacyDocumentEditModal}
          />
        ))}
      </Table.Body>
    </Table>
    <div className="options">
      <Button
        blue
        className="uploadLegacyDocument"
        onClick={openLegacyDocumentUploadModal}>
        Upload Document
      </Button>
    </div>
  </div>
);

export default LegacyDocumentsTable;
